import React, { useState } from 'react'
import PropTypes from 'prop-types'
import WebIcon from 'mdi-react/MonitorIcon';
import AppIcon from 'mdi-react/CellphoneIcon'
import EditEmailTemplate from './EditEmailTemplate';

const EmailTemplate = ({
  emailTemplate,
  hidePreview,
  handlePreview,
  loadingTemplate,
  program,
  eventTypeId,
  event,
  sendPreviewEmail,
}) => {
  const [templateView, setTemplateView] = useState("web");
  const [editMode, setEditMode] = useState(false);

  return (
    <div className="email-template">
      {!emailTemplate && !loadingTemplate && (
        <button
          type="button"
          className="email-template__preview-btn"
          onClick={handlePreview}
        >
          <WebIcon size={15} />
          Preview Email Template
        </button>
      )}

      {loadingTemplate && (
        <div className="email-template__loading">
          <span className="email-template__loading-spinner" />
          Loading template…
        </div>
      )}

      {emailTemplate && (
        <div className="email-template__panel">
          <div className="email-template__toolbar">
            <div className="email-template__toolbar-left">
              <span className="email-template__toolbar-label">Email Preview</span>
            </div>
            <div className="email-template__toolbar-right">
              <div className="email-template__view-toggle">
                <button
                  type="button"
                  className={`email-template__view-btn${templateView === 'web' ? ' is-active' : ''}`}
                  onClick={() => setTemplateView('web')}
                  title="Desktop view"
                >
                  <WebIcon size={14} />
                  <span>Desktop</span>
                </button>
                <button
                  type="button"
                  className={`email-template__view-btn${templateView === 'app' ? ' is-active' : ''}`}
                  onClick={() => setTemplateView('app')}
                  title="Mobile view"
                >
                  <AppIcon size={14} />
                  <span>Mobile</span>
                </button>
              </div>
              <button
                type="button"
                className="email-template__send-btn"
                onClick={sendPreviewEmail}
              >
                Send Test
              </button>
              <button
                type="button"
                className="email-template__hide-btn"
                onClick={hidePreview}
              >
                Close
              </button>
            </div>
          </div>

          <div className={`email-template__viewport${templateView === 'app' ? ' email-template__viewport--mobile' : ''}`}>
            <div
              className="email-template__content"
              dangerouslySetInnerHTML={{ __html: emailTemplate }}
            />
          </div>
        </div>
      )}

      {emailTemplate && editMode && (
        <EditEmailTemplate
          template={emailTemplate}
          program={program}
          editMode={editMode}
          toggleEditMode={() => setEditMode(s => !s)}
          eventTypeId={eventTypeId}
          event={event}
        />
      )}
    </div>
  );
};

EmailTemplate.propTypes = {
  emailTemplate: PropTypes.string,
  hidePreview: PropTypes.func.isRequired,
  handlePreview: PropTypes.func.isRequired,
  loadingTemplate: PropTypes.bool.isRequired,
  program: PropTypes.object,
  eventTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  event: PropTypes.object,
  sendPreviewEmail: PropTypes.func.isRequired,
};

export default EmailTemplate;
